<template>
  <SectionPageShell section="inquiries" title="Anfragen">
    <p class="text-muted">
      Anfragen, die in den letzten 12 Monaten über die Anfrageformulare Ihrer Einträge zugestellt wurden.
    </p>

    <DataTable
      :value="inquiriesStore.items"
      :rows="inquiriesStore.serverOptions.rows"
      :totalRecords="inquiriesStore.totalRecords"
      :loading="inquiriesStore.loading"
      :lazy="true"
      paginator
      dataKey="id"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[20,50,100]"
      currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords}"
      responsiveLayout="scroll"
      @page="onPage"
    >
      <template #empty>
        Keine Anfragen gefunden.
      </template>

      <TableColumn field="in_at" header="Eingang">
        <template #body="{ data }">
          {{ formatDate(data.in_at, 'datetime') }}
        </template>
      </TableColumn>

      <TableColumn field="route" header="Formular" />
      <TableColumn field="sender" header="Absender" />
      <TableColumn field="subject" header="Betreff" />

      <TableColumn header="">
        <template #body="{ data }">
          <router-link :to="{ name: 'inquiries.show', params: { id: data.id } }" class="btn btn-outline-primary btn-sm">
            Anzeigen
          </router-link>
        </template>
      </TableColumn>
    </DataTable>
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import { useInquiriesStore } from "@/stores/inquiries";
import { useUserStore } from "@/stores/user";

export default {
  name: "InquiriesIndexPage",
  components: {
    SectionPageShell,
  },
  setup() {
    return {
      inquiriesStore: useInquiriesStore(),
    }
  },
  created() {
    this.inquiriesStore.index()
    useUserStore().user.markInquiriesSeen()
  },
  methods: {
    onPage(event) {
      this.inquiriesStore.serverOptions = event
      this.inquiriesStore.index()
    },
  },
}
</script>
